module.exports = __webpack_public_path__ + "static/img/aoc1.fb835df9.gif";